import DropBox from "../../../../component/DropBox";
import { useMonthSettlementContext } from "../../hooks/month-settlement-context";
import { useMonthExcel } from "../../hooks/use-month-excel";
import { MonthSettlementSection } from "../../hooks/use-month-settlement-section";
import {
  DailySettlementTabWrapper,
  DailySettlementTabButtonWrapper,
  DailySettlementDateWrapper,
} from "../../../daily-settlement/components/tab/style";

const monthList = Array.from({ length: 12 }, (_, i) => ({
  name: `${i + 1}월`,
  value: i + 1,
}));

const yearList = [
  { name: "2026년", value: 2026 },
  { name: "2027년", value: 2027 },
  { name: "2028년", value: 2028 },
];

const MonthSettlementTab = () => {
  const { year, setYear, month, setMonth, isSection, setSection } =
    useMonthSettlementContext();
  const { createMonthFile } = useMonthExcel();

  const tabs = [
    { name: "결산", tab: MonthSettlementSection.CLOSING },
    { name: "월간 매출", tab: MonthSettlementSection.REVENUE },
    { name: "월간 지출", tab: MonthSettlementSection.EXPENSE },
    { name: "당기 순이익", tab: MonthSettlementSection.NET_INCOME },
  ];

  const handleExcel = () => {
    createMonthFile(year, month);
  };

  return (
    <DailySettlementTabWrapper>
      <DailySettlementTabButtonWrapper>
        {tabs.map((t, i) => (
          <div
            key={i}
            className={`button ${isSection(t.tab) ? "selected" : ""}`}
            onClick={() => setSection(t.tab)}
          >
            {t.name}
          </div>
        ))}
      </DailySettlementTabButtonWrapper>
      <DailySettlementDateWrapper>
        <DropBox
          value={year}
          setValue={setYear}
          list={yearList}
          isBig={true}
          width="69px"
        />
        <DropBox
          value={month}
          setValue={setMonth}
          list={monthList}
          isBig={true}
          width="40px"
        />
        <div className="save" onClick={handleExcel}>
          <img src="/image-web/solution/save.svg" alt="save" />
        </div>
      </DailySettlementDateWrapper>
    </DailySettlementTabWrapper>
  );
};

export default MonthSettlementTab;
